export function getTicketValues(order, additionalQuestions, formTickets) {
  if (formTickets) {
    return formTickets;
  }
  if (!order || !order.tickets || !order.tickets.length) {
    return null;
  }
  let mappedTicketValues = {};
  order.tickets.forEach(ticket => {
    mappedTicketValues[ticket._id] = {};
    if (ticket.additionalFields && ticket.additionalFields.length > 0) {
      ticket.additionalFields.forEach(field => {
        const isAddress = field.details && field.details.country;
        if (isAddress) {
          mappedTicketValues[ticket._id][field.questionId] = {
            location: field.value,
            details: field.details
          };
        } else {
          mappedTicketValues[ticket._id][field.questionId] = field.value;
        }
      });
    } else if (additionalQuestions && additionalQuestions.length > 0) {
      additionalQuestions.forEach(question => {
        if (
          question.defaultValue &&
          !question.perOrder &&
          !question.askAfterCheckout
        ) {
          mappedTicketValues[ticket._id][question._id] = question.defaultValue;
        }
      });
    }
  });
  return mappedTicketValues;
}



// WEBPACK FOOTER //
// ./utils/stateConstructors.js